import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  export class PermissaoModeloService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
      this.url = env.url + "permissao-template";
      
      this.controladoresDeInstancia = {
        verificarPermissaoPorId: new AbortController(),
        verificarPermissao: new AbortController(),
        atualizarPermissaoPorId: new AbortController(),
        atualizarPermissao: new AbortController(),
        verificarDados: new AbortController()
      }
    }
  
    async verificarPermissaoPorId(id, controlador) {
      this.controladoresDeInstancia.verificarPermissaoPorId = this.selecionarControlador(controlador);
      return super.get(`${this.url}/verificarpermissao/${id}`, this.controladoresDeInstancia.verificarPermissaoPorId);
    }

    async atualizarPermissaoPorId(id, controlador) {
      this.controladoresDeInstancia.atualizarPermissaoPorId = this.selecionarControlador(controlador);
      return super.get(`${this.url}/atualizarPermissao/${id}`, this.controladoresDeInstancia.atualizarPermissaoPorId);
    }

    async verificarPermissao(modelo, controlador) {
      const endpoint = `${this.url}/verificarpermissao`
      this.controladoresDeInstancia.verificarPermissao = this.selecionarControlador(controlador);
      const response = await super.post(endpoint, modelo, this.controladoresDeInstancia.verificarPermissao);
      if (response.ok) {
          return response.json();
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível verificar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }

    async atualizarPermissao(modelo, controlador) {
      const endpoint = `${this.url}/atualizarPermissao`
      this.controladoresDeInstancia.atualizarPermissao = this.selecionarControlador(controlador);
      const response = await super.post(endpoint, modelo, this.controladoresDeInstancia.atualizarPermissao);
      if (response.ok) {
          return response;
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível atualizar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }

    async verificarDados(modelo, campos = ['nome'], controlador) {
      const endpoint = `${this.url}/verificardados`
      const itensVerificaveis = {};
      for await (let item of campos) {
        itensVerificaveis[item] = modelo[item];
      };
      this.controladoresDeInstancia.verificarDados = this.selecionarControlador(controlador);
      const response = await super.post(endpoint, itensVerificaveis, this.controladoresDeInstancia.verificarDados);
      if (response.ok) {
          return response.json();
      } else {
          const toastUtils = await this.adquirirToastUtils();
          toastUtils.dangerToast("Não foi possível atualizar permissões do(s) usuário(s).");
          throw new Error('HTTP ' + response.status);
      }
    }
  }
  
  export const permissaoModeloService = new PermissaoModeloService()
  